import { TableCell } from "@mui/material";
import { useState } from "react";
import { toast } from "react-toastify";
import { Button } from "src/Components";
import { IConflictTableReport } from "src/Interfaces/applyOption";
import { manualSendPlanRow } from "src/Requests/applyOption";
import { IAdditional } from "src/Tables/TableTemplate/tableTemplate";
import { packetErrorHandler } from "src/Utils/requestUtils";

const AdditionalHeader: React.FC = () => {
  return <TableCell />;
};

const AdditionalCol: React.FC<{
  row: IConflictTableReport;
  onAction: () => void;
}> = ({ row, onAction }) => {
  const [loading, setLoading] = useState(false);

  const sendManual = () => {
    if (!row.planId) return;

    setLoading(true);
    manualSendPlanRow(row.planId)
      .then((resp) => {
        onAction();
        if (!resp.data) toast.error(resp.msg);
        else toast.success(resp.msg);
      })
      .catch(packetErrorHandler)
      .finally(() => setLoading(false));
  };

  return (
    <TableCell>
      <Button
        onClick={sendManual}
        text="ارسال دستی"
        variant="contained"
        className="table-btn"
        disabled={loading}
      />
    </TableCell>
  );
};

export const Additional: IAdditional<IConflictTableReport> = {
  getHeader: AdditionalHeader,
  getRow: AdditionalCol,
};
